import React, { useEffect, useState } from 'react'
import axios from '../../Utilities/axios'
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from '../../assets/logoSecond.png'
import './Navbar.css'
import SpinnerPage from './SpinnerPage';

const Navbar = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  let availableHotel

  const navigation = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const getHotels = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const mainAvailableHotel = await axios.get(`/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`);

    availableHotel = mainAvailableHotel.data
    setIsLoading(false);
    navigation("/availablehotels", { state: { availableHotel: availableHotel } })
  }

  const isActive = (path) =>
    pathname === path ? " is-active" : "";

  return (
    <>
      {isLoading && <SpinnerPage />}

      <nav
        className={`navbar navbar-expand-lg site-nav ${
          isScrolled ? "is-scrolled" : ""
        }`}
        aria-label="Main navigation"
      >
        <div className="container">
          <div className="site-nav__inner">
            <Link to="/" className="site-nav__brand">
              <img src={logo} alt="Residency Hotels" />
            </Link>

            <button
              className="navbar-toggler shadow-none site-nav__toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#siteNavMenu"
              aria-controls="siteNavMenu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="site-nav__burger" />
              <span className="site-nav__burger" />
              <span className="site-nav__burger" />
            </button>

            <div className="collapse navbar-collapse site-nav__menu" id="siteNavMenu">
              <div className="site-nav__links ms-auto">
                <Link
                  to="/About-Residency-Hotels"
                  className={`site-nav__link${isActive("/About-Residency-Hotels")}`}
                >
                  About
                </Link>
                <Link
                  to="/Special-Promo"
                  className={`site-nav__link${isActive("/Special-Promo")}`}
                >
                  Our Special Promo
                </Link>
                <Link
                  to="/EventHall"
                  className={`site-nav__link${isActive("/EventHall")}`}
                >
                  Our Event
                </Link>
                <a
                  className="site-nav__link site-nav__link--action"
                  onClick={(event) => getHotels(event)}
                >
                  Our Hotels
                </a>
                <button
                  type="button"
                  className="site-nav__book"
                  onClick={(event) => getHotels(event)}
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar